<template>
    <div v-if="showWidget">
        <i
            class="icon icon-tool mr-3 cursor-pointer"
            @click="show = true"
        />
        <b-modal
            v-model="show"
            :title="$t('settings.main.externalServices.modal')"
            hideFooter
            lazy
            headerCloseContent=""
        >
            <external-service-list />
        </b-modal>
    </div>
</template>

<script>
import access from '@/mixins/access';
import ExternalServiceList from '@/components/settings/ExternalServiceList';

export default {
    name: 'TopExternalService',

    components: { ExternalServiceList },

    mixins: [access],

    data() {
        return {
            show: false,
        };
    },

    computed: {
        showWidget: vm => vm.checkAccess('settingsManageExternalServices') && vm.$route.name !== 'SettingExternalService',
    },
};
</script>